import React, { useEffect, useRef } from 'react';
import { SchoolTimezoneInput } from 'features/schools/SchoolTimezoneInput';
import { isValidTimezone } from 'utils/timezones';
import Form from 'react-bootstrap/Form';

import SingleTextField from './SingleTextField/SingleTextField';
import SelectField from './SelectField/SelectField';
import ColorPickerField from './ColourPickerField/ColorPickerField';
import SwitchField from './SwitchField/SwitchField';
import NumericField from './NumericField/NumericField';
import AddressAutoCompleteField from './AddressAutoCompleteField/AddressAutoCompleteField';
import TagInputField from './TagInputField/TagInputField';
import FileBox from '../FileBox/FileBox';
import MessageField from './MessageField/MessageField';
import XHRSelectField from './XHRSelectField/XHRSelectField';

const TimezoneField = ({
  field,
  updateParent,
  form,
  autofillTimezoneOnlyIfEmpty,
}) => {
  const initialized = useRef(false);
  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;
    field.valid = isValidTimezone(field.currentValue);
    updateParent(field.currentValue, field);
  }, [field, updateParent]);

  return (
    <Form.Group>
      <SchoolTimezoneInput
        autofillOnlyIfEmpty={autofillTimezoneOnlyIfEmpty}
        latitude={form.lat}
        longitude={form.lng}
        value={field.currentValue}
        onChange={(value) => {
          field.valid = isValidTimezone(value);
          updateParent(value, field);
        }}
      />
    </Form.Group>
  );
};

const FieldsContainer = ({
  fields,
  updateParent,
  form = {},
  onCoordinatePaste,
  autofillTimezoneOnlyIfEmpty,
}) => {
  const getFieldComponent = (field) => {
    switch (field.type) {
      case 'TimezoneField':
        return TimezoneField;
      case 'SingleTextField':
        return SingleTextField;
      case 'TagInputField':
        return TagInputField;
      case 'SelectField':
        return SelectField;
      case 'XHRSelectField':
        return XHRSelectField;
      case 'ColorPickerField':
        return ColorPickerField;
      case 'GoogleAutoCompleteField':
        return AddressAutoCompleteField;
      case 'FileBox':
        return FileBox;
      case 'SwitchField':
        return SwitchField;
      case 'NumericField':
        return NumericField;
      case 'MessageField':
        return MessageField;
      default:
        return null;
    }
  };

  return (
    <Form>
      {fields.map((field, i) => {
        const Component = getFieldComponent(field);

        if (!Component) {
          console.warn('Encountered step type without a matching component.');
          return (
            <div style={{ color: '#f00', paddingLeft: '20px' }} key={i}>
              Missing field
            </div>
          );
        }

        return (
          <Component
            key={field.prop}
            field={field}
            form={form}
            updateParent={updateParent}
            onCoordinatePaste={onCoordinatePaste}
            autofillTimezoneOnlyIfEmpty={autofillTimezoneOnlyIfEmpty}
          />
        );
      })}
    </Form>
  );
};

export default FieldsContainer;
